import React, { useState, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  RadioGroup,
  Radio,
  DialogContent,
  DialogActions,
  FormControlLabel,
  IconButton,
  Button,
  Tooltip,
} from '@material-ui/core';
import { TransferWithinAStation } from '@material-ui/icons';
import { Mutation } from '@apollo/client/react/components';
import { useQuery } from '@apollo/client';
import Loading from '../../../components/Loading';
import { UPDATE_TITLE_WRITER } from '../../../queries/titleContent';
import { GET_WRITERS } from '../../../queries/user';

interface ISelectWriterProps {
  selectedTitles: Map<string, ITitle>;
  refetch: any;
  clearSelectedCheckboxes: () => void;
}

const SelectWriter: React.FC<ISelectWriterProps> = ({
  selectedTitles,
  refetch,
  clearSelectedCheckboxes,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedWriterId, setSelectedWriterId] = useState('');
  const [openLoading, setOpenLoading] = useState(false);
  const { loading, error, data } = useQuery(GET_WRITERS);
  const radioGroupRef = useRef<HTMLElement>();

  const handleEntering = () => {
    if (radioGroupRef.current) {
      radioGroupRef.current.focus();
    }
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedWriterId(event.target.value);
  };

  const handleConfirm = async (updateWriterTitle: any) => {
    setOpen(!open);
    if (selectedWriterId === null) return;
    setOpenLoading(true);
    try {
      const promises = Array.from(selectedTitles).map(async ([, title]) => {
        await updateWriterTitle({
          variables: { id: title.id, writerId: selectedWriterId },
        });
      });

      await Promise.all(promises);
    } catch (error) {
      setOpenLoading(!openLoading);
    } finally {
      setOpenLoading(false);
      clearSelectedCheckboxes();
      refetch();
    }
  };

  return (
    <Mutation mutation={UPDATE_TITLE_WRITER}>
      {(updateWriterTitle: any) => (
        <>
          <Tooltip title="Change writer">
            <IconButton
              color="primary"
              aria-label="forward"
              onClick={(e) => {
                e.preventDefault();
                setOpen(true);
              }}
            >
              <TransferWithinAStation />
            </IconButton>
          </Tooltip>
          <Loading openLoading={openLoading} />
          {!loading && !error && data.userWriters && (
            <Dialog
              disableBackdropClick
              disableEscapeKeyDown
              maxWidth="xs"
              onEntering={handleEntering}
              aria-labelledby="select-writer-title"
              onClose={handleClose}
              open={open}
            >
              <DialogTitle id="select-writer-title">
                Select a writer
              </DialogTitle>
              <DialogContent dividers>
                <RadioGroup
                  ref={radioGroupRef}
                  aria-label="ringtone"
                  name="ringtone"
                  value={selectedWriterId}
                  onChange={handleChange}
                >
                  {!loading &&
                    !error &&
                    data.userWriters.map((writer: any) => (
                      <FormControlLabel
                        value={writer.id}
                        key={writer.id}
                        control={<Radio />}
                        label={writer.name}
                      />
                    ))}
                </RadioGroup>
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => handleConfirm(updateWriterTitle)}
                  color="primary"
                  variant="contained"
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </Mutation>
  );
};

export default SelectWriter;
